import React from 'react';
import { EmptyState, EmptyStateBody } from '@patternfly/react-core';
import { EnvelopeIcon } from '@patternfly/react-icons';

const ServerEmailTab: React.FunctionComponent = () => (
  <EmptyState
    titleText="Email management coming soon."
    icon={EnvelopeIcon}
    variant="lg"
    headingLevel="h2"
    style={{ marginTop: '1rem' }}
  >
    <EmptyStateBody>Mailbox, domain, and alias configuration will be displayed here.</EmptyStateBody>
  </EmptyState>
);

export default ServerEmailTab;
